import { DestroyRef, Directive, ElementRef, afterRenderEffect, inject, input } from '@angular/core';

/**
 * Reduce el tamaño de letra hasta que el texto quepa en una línea del contenedor padre;
 * si ni con el mínimo cabe, permite que se parta en varias líneas.
 */
@Directive({
  selector: '[appFitText]',
  standalone: true
})
export class FitTextDirective {
  text = input<string | null | undefined>('', { alias: 'appFitText' });
  maxPx = input(32);
  minPx = input(10);

  private el = inject(ElementRef<HTMLElement>).nativeElement as HTMLElement;

  constructor() {
    const observer = new ResizeObserver(() => this.fit());
    if (this.el.parentElement) observer.observe(this.el.parentElement);
    inject(DestroyRef).onDestroy(() => observer.disconnect());
    afterRenderEffect(() => {
      this.text();
      this.fit();
    });
  }

  private fit(): void {
    const parent = this.el.parentElement;
    if (!parent) return;
    const style = getComputedStyle(parent);
    const available = parent.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    if (available <= 0) return;
    this.el.style.whiteSpace = 'nowrap';
    this.el.style.fontSize = `${this.maxPx()}px`;
    const width = this.el.scrollWidth;
    if (width <= available) return;
    const size = Math.max(this.minPx(), Math.floor((this.maxPx() * available) / width));
    this.el.style.fontSize = `${size}px`;
    if (this.el.scrollWidth > available) {
      this.el.style.whiteSpace = 'normal';
      this.el.style.overflowWrap = 'anywhere';
    }
  }
}
